import React from 'react';
import { ExpandLess, ExpandMore } from '@vedmarket/ui-kit';
import { Link } from 'react-router-dom';

import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { COLORS } from '../../../../config/constants';

type MenuSectionProps = {
    title: React.ReactNode;
    items?: React.ReactNode[];
    to?: string;
    isActive?: boolean;
    itemTo?: string;
};

const renderMenuLabel = (
    text: React.ReactNode,
    marker = '○',
    markerClassName = '',
) => (
    <span className='menu-list__section-title'>
        <span className={`menu-list__section-marker ${markerClassName}`}>{marker}</span>
        <span className='menu-list__section-title-text'>{text}</span>
    </span>
);

const MenuSection = ({ title, items, to, isActive, itemTo }: MenuSectionProps) => {

    const [open, setOpen] = React.useState(true)
    const hasItems = Boolean(items?.length)

    const handleToggle = () => setOpen(!open)

    return (
        <>
            <ListItemButton
                component={to ? Link : 'div'}
                to={to}
                sx={{
                    paddingTop: '4px',
                    paddingBottom: '4px',
                    color: 'inherit',
                    textDecoration: 'none',
                    '&.MuiButtonBase-root': {
                        minHeight: '44px',
                        height: 'auto',
                    },
                    ...(isActive && {
                        backgroundColor: COLORS.LIGHT_BLUE,
                    }),
                }}
                onClick={hasItems ? handleToggle : undefined}
            >
                <ListItemText
                    primary={renderMenuLabel(title)}
                    sx={{
                        paddingLeft: 1,
                        marginTop: 0,
                        marginBottom: 0,
                    }}
                />
                {hasItems && (open ? <ExpandLess/> : <ExpandMore/>)}
            </ListItemButton>
            {hasItems && (
                <Collapse in={open} timeout='auto' unmountOnExit>
                    <List component='div' disablePadding>
                        {items?.map((item) => (
                            <ListItemButton
                                component={itemTo ? Link : 'div'}
                                to={itemTo}
                                sx={{
                                    pl: 5,
                                    color: 'inherit',
                                    textDecoration: 'none',
                                    '&.MuiButtonBase-root': {
                                        minHeight: '38px',
                                        height: 'auto',
                                    },
                                }}
                                key={`${item}`}
                            >
                                <ListItemText
                                    secondary={renderMenuLabel(item, '•', 'menu-list__section-marker_big')}
                                    secondaryTypographyProps={{
                                        color: COLORS.BLACK,
                                    }}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                </Collapse>
            )}
        </>
    )
};

export default MenuSection;
